import { render, staticRenderFns } from "./WorkplaceActivitiesTable.vue?vue&type=template&id=64b82c50&scoped=true&"
import script from "./WorkplaceActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./WorkplaceActivitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b82c50",
  null
  
)

export default component.exports